<template>
  <article
    class="day-meal-item-article"
    :style="dayMealStyle"
    :class="{ selected: isSelected }"
  >
    <Icon v-if="updatable" class="drag-icon handle" icon="fas fa-arrows-alt" />
    <div @click="onClick(id)" class="meal" :class="{ deleted: isMealDeleted }">
      <h3>{{ title }}</h3>
    </div>
    <button
      v-if="updatable"
      @click="$emit('delete', id)"
      :class="{ 'no-gradient': isDefaultMeal }"
    >
      <Icon icon="fas fa-times" />
    </button>
  </article>
</template>

<script>
import _ from 'lodash';

export default {
  components: {},
  props: {
    plannedMeal: {
      type: Object,
      required: true,
    },
    updatable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick(id) {
      if (this.updatable) {
        this.$emit('click', id);
      }
      if (this.selectable) {
        this.$emit('select', id);
      }
    },
  },
  computed: {
    isMealDeleted() {
      return _.get(this.plannedMeal, 'isMealDeleted', false);
    },
    id() {
      return _.get(this.plannedMeal, 'id', false);
    },
    title() {
      return _.get(this.plannedMeal, 'meal.title', '');
    },
    ingredients() {
      return _.get(this.plannedMeal, 'meal.ingredients', []);
    },
    ingredientsList() {
      const maxLength = 30;
      let str = `(${this.ingredients.join(', ')})`;
      if (str.length > maxLength) {
        str = `${str.substring(0, maxLength)}...`;
      }
      return str;
    },
    image() {
      return _.get(this.plannedMeal, 'meal.img', null);
    },
    isDefaultMeal() {
      return _.get(this.plannedMeal, 'meal.isDefaultMeal', false);
    },
    isSelected() {
      return this.selectable && _.get(this.plannedMeal, 'selected', false);
    },
    dayMealStyle() {
      const rgba = 'rgba(0, 0, 0, 0.4)';
      const style = {};
      if (this.isDefaultMeal) {
        style.background = '#1369a7';
        style.backgroundImage = 'initial';
      }
      if (this.image) {
        style.backgroundImage = `linear-gradient(${rgba}, ${rgba}), url(${this.image})`;
      }
      return style;
    },
  },
};
</script>

<style lang="scss" scoped src="./DayMealItem.scss"></style>
